import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@app/store/authStore';

const ROLE_PATHS: Record<string, string> = {
  patient: '/patient/dashboard',
  doctor: '/clinician/dashboard',
  nurse: '/clinician/dashboard',
  physician_assistant: '/clinician/dashboard',
  pharmacist: '/pharmacy/dashboard',
  lab_tech: '/laboratory/dashboard',
  admin: '/admin/dashboard',
  super_admin: '/admin/dashboard',
  receptionist: '/facility/dashboard',
};

interface AuthGuardProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export default function AuthGuard({ children, allowedRoles }: AuthGuardProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to={ROLE_PATHS[user.role] || '/patient/dashboard'} replace />;
  }

  return <>{children}</>;
}
